<template>
  <v-dialog
    width="500px"
    :value="showNewEditProductDialog"
    @input="resetNewProduct"
    persistent
    scrollable
  >
    <v-card class="kbLight">
      <v-toolbar class="kbGold" dark text flat>
        <div class="text-h6">
          {{
            methodNewEditProduct === "edit"
              ? $t("general.editProduct")
              : $t("general.newProduct")
          }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="resetNewProduct">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validProduct" ref="newEditProductForm" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Sku"
                color="kbDarkBlue"
                :rules="[rules.required]"
                v-model="newEditProductObj.sku"
                :readonly="readonly"
                autofocus
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('general.name')"
                color="kbDarkBlue"
                :rules="[rules.required]"
                v-model="newEditProductObj.name"
                @keyup.enter="submit"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('general.price')"
                color="kbDarkBlue"
                v-model="newEditProductObj.price"
                @keyup.enter="submit"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('general.description')"
                color="kbDarkBlue"
                v-model="newEditProductObj.description"
                @keyup.enter="submit"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('general.discountPrice')"
                color="kbDarkBlue"
                v-model="newEditProductObj.discountPrice"
                @keyup.enter="submit"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('general.stock')"
                color="kbDarkBlue"
                v-model="newEditProductObj.stock"
                @keyup.enter="submit"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="newEditProductObj.placeId"
                :items="places"
                item-text="name"
                item-value="id"
                label="Place"
                :readonly="readonly"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="newEditProductObj.productsCategories"
                :items="productsCategories"
                item-text="name"
                item-value="_id"
                label="Products Categories"
                :readonly="readonly"
                multiple
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                hide-details
                :label="$t('general.active')"
                color="kbDarkBlue"
                v-model="newEditProductObj.active"
                :readonly="readonly"
              />
            </v-col>

            <template v-for="(image, index) in newEditProductObj.images">
              <v-col cols="12" md="4" :key="index" class="edit-image">
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card
                      :elevation="hover ? 12 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-img
                        :src="image"
                        style="border-radius: 5px;"
                        alt="Product photo"
                      />
                      <v-fade-transition>
                        <v-overlay
                          v-if="hover && !readonly"
                          absolute
                          color="kbGold"
                        >
                          <!-- <v-btn
                            dark
                            icon
                            x-large
                          >
                            <v-icon
                              dark
                            >
                              mdi-clear
                            </v-icon>
                          </v-btn> -->
                          <v-btn @click="spliceImage(index)">Borrar</v-btn>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </template>
                </v-hover>
              </v-col>
            </template>
            <template
              v-if="
                newEditProductObj.miniatureSvg &&
                  newEditProductObj.miniatureSvg.url
              "
            >
              <v-col cols="12">
                Foto Miniatura:
              </v-col>
              <v-col cols="12" md="4" class="miniature-svg-image">
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card
                      :elevation="hover ? 12 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-img
                        :src="newEditProductObj.miniatureSvg.url"
                        style="border-radius: 5px;"
                        alt="Product miniature photo"
                      />
                      <v-fade-transition>
                        <v-overlay
                          v-if="hover && !readonly"
                          absolute
                          color="kbGold"
                        >
                          <v-btn @click="removeMiniaturePhoto(index)"
                            >Borrar</v-btn
                          >
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </template>
                </v-hover>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="readonly">
          <v-btn color="kbGold" dark @click="submit">
            {{ $t("general.close") }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn class="mr-2" color="red" outlined @click="resetNewProduct"
            >Cancelar</v-btn
          >
          <v-btn
            color="kbGold"
            dark
            @click="submit"
            :loading="loadingSubmitNewUpdateProduct"
          >
            {{
              methodNewEditProduct === "edit"
                ? $t("general.editProduct")
                : $t("general.newProduct")
            }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  components: {},
  computed: {
    ...mapState({
      loadingSubmitNewUpdateProduct: state =>
        state.events.loadingSubmitNewUpdateProduct,
      methodNewEditProduct: state => state.events.methodNewEditProduct,
      places: state => state.events.places,
      productsCategories: state => state.events.productsCategories
    }),
    newEditProductObj: {
      get () {
        return this.$store.state.events.newEditProductObj
      },
      set (value) {
        this.$store.commit('SET_NEW_EDIT_PRODUCT_OBJ', value)
      }
    },
    showNewEditProductDialog: {
      get () {
        return this.$store.state.events.showNewEditProductDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PRODUCT_DIALOG', value)
      }
    },
    readonly () {
      return this.methodNewEditProduct === 'view'
    }
  },
  data () {
    return {
      validProduct: false,
      rules
    }
  },
  methods: {
    async submit () {
      try {
        if (await !this.$refs.newEditProductForm.validate()) { return notifications.error('Complete los campos requeridos') }
        if (this.methodNewEditProduct === 'view') {
          this.showNewEditProductDialog = !this.showNewEditProductDialog
        }
        if (this.methodNewEditProduct === 'new') {
          const response = await this.$store.dispatch('createProduct')
          if (response) {
            notifications.success('Producto creado correctamente')
            this.resetNewProduct()
            // TODO: ask if method was create and emit event to open modal upload product photo
          }
        }
        if (this.methodNewEditProduct === 'edit') {
          const response = await this.$store.dispatch('updateProduct')
          if (response) {
            notifications.success('Producto actualizado correctamente')
            this.resetNewProduct()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    spliceImage (index) {
      this.newEditProductObj.images.splice(index, 1)
    },
    removeMiniaturePhoto (index) {
      this.newEditProductObj.miniatureSvg = {}
    },
    resetNewProduct () {
      this.$refs.newEditProductForm.reset()
      this.showNewEditProductDialog = !this.showNewEditProductDialog
    }
  },
  watch: {
    showNewEditProductDialog: {
      handler (value) {
        if (!value) {
          this.newEditProductObj = {}
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped></style>
